export default "<html>\n  <head>\n    <title><%= title %></title>\n  </head>\n  <body>\n    <h1><%= tilte %></h1>\n  </body>\n</html>\n";